import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// Determine base URL based on environment
export const getBaseURL = () => {
    const mode = import.meta.env.MODE;
    
    if (mode === 'production') {
        return import.meta.env.VITE_API_URL_PROD || 'https://workwear.barodaweb.org';
    }
    
    return import.meta.env.VITE_API_URL_DEV || 'http://localhost:8012';
};

// Get or create guest ID
export const getGuestId = () => {
    let guestId = localStorage.getItem('guestId');
    if (!guestId) {
        guestId = uuidv4();
        localStorage.setItem('guestId', guestId);
    }
    return guestId;
};

// Get auth token
export const getAuthToken = () => {
    return localStorage.getItem('token');
};

// Create axios instance with default config
const apiClient = axios.create({
    baseURL: getBaseURL(),
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        // Add auth token if available
        const token = getAuthToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            // Add guest ID if no token
            const guestId = getGuestId();
            config.headers['x-guest-id'] = guestId;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle common errors
        if (error.response) {
            const { status } = error.response;
            
            // Handle unauthorized errors
            if (status === 401 || status === 403) {
                // Token might be expired, clear it
                const event = new CustomEvent('auth:unauthorized', {
                    detail: { message: 'Session expired. Please log in again.' }
                });
                window.dispatchEvent(event);
            }
            
            // Handle server errors
            if (status >= 500) {
                console.error('Server error:', error.response.data);
            }
        } else if (error.request) {
            // Network error
            console.error('Network error:', error.message);
        }
        
        return Promise.reject(error);
    }
);

// Export base URL for cases where direct URL is needed (like image URLs)
export const API_BASE_URL = getBaseURL();

// Export the configured axios instance
export default apiClient;
